import { useSelector } from 'react-redux'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from './store'
import { useDispatchActions, setStoreState } from './utils'
import { storageUtil } from '@/utils'
import type { ICountryItem } from '@/types/common';


const initialState: ICountryItem[] = []

export const slice = createSlice({
  name: 'countryList',
  initialState,
  reducers: {
    setCountryList: (state, action: PayloadAction<ICountryItem[]>) => {
      const payload = action.payload
      setStoreState(state, payload)
      storageUtil.setSessionStorage('countryList', JSON.stringify(payload))
    },
    // 清除 countryList 的方法
    clearCountryList: (state) => {
      setStoreState(state, initialState)
      storageUtil.removeSessionStorage('countryList')
    }
  },
})

export const { setCountryList: countryListActionCreator } = slice.actions
export const reducer = slice.reducer

export default function useCountryListStore() {
  const state = useSelector((state: RootState) => state.countryList)
  const storageState = storageUtil.getSessionStorage('countryList', true) || {}
  const actionPool = useDispatchActions(slice.actions)
  const totalState = { ...state, ...storageState }

  return {
    countryList: totalState,
    ...actionPool,
  }
}
